"use client"

import type { ComponentProps } from "react"
import { useI18n } from "@/i18n/client"
import { normalizeBookingHref } from "@/modules/booking/channel-links"

/** A real navigation lets the gateway choose the latest channel without prefetch. */
export function BookingLink({ href = "/book/", ...props }: ComponentProps<"a">) {
  const { href: localizedHref } = useI18n()
  return <a {...props} href={localizedHref(normalizeBookingHref(href))} />
}
